import styled from 'styled-components';
import { Typography } from '../../../assets/styles/StyleTypes';

export const Table = styled.div`
  width: 100%;
  height: 100%;
  min-height: 0;
  min-width: 0;
  ${Typography.HELPER_XXS}
  color: ${(props) => props.theme.colors.textPrimary};
  display: flex;
  flex-direction: column;
  overflow-x: auto;
  overflow-y: hidden;
  border-radius: 10px;

  &#details-equipment {
    overflow-x: hidden;
  }

  &.full-width-mobile {
    width: 100%;
  }

  @media screen and (max-width: 960px) {
    &#table-equipments,
    &#table-update-equipments {
      border-radius: 10px;
      box-shadow: 0 0 0.7em ${props => props.theme.colors.boxShadow};
      margin-top: 20px;
    }

    &.full-width-mobile {
      min-width: 0;
      overflow-x: hidden;
    }
  }
`;

